import { MijnRoute } from '../../mijn-navigatie.model';

export const OVERVIEW: MijnRoute = {
    path: '',
    navigationEvent: 'toHomepage',
    regex: /^\/$/,
    webcomponent: 'mijn-overzicht'
};
